import { render, staticRenderFns } from "./Marathon.vue?vue&type=template&id=215815ba&scoped=true&"
import script from "./Marathon.vue?vue&type=script&lang=js&"
export * from "./Marathon.vue?vue&type=script&lang=js&"
import style0 from "./Marathon.vue?vue&type=style&index=0&id=215815ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215815ba",
  null
  
)

export default component.exports